export const CONFIGURABLE_PROFILE_REQUEST = 'CONFIGURABLE_PROFILE_REQUEST';
export const CONFIGURABLE_PROFILE_SUCCESS = 'CONFIGURABLE_PROFILE_SUCCESS';
export const CONFIGURABLE_PROFILE_FAIL = 'CONFIGURABLE_PROFILE_FAIL';

